import MainContent from '../../../layouts/maincontent/MainContent';
import { useContext, useEffect, useState } from "react";
import { TaxDeclartionContext } from "../../../contexts/TaxDeclaration";
import { jsPDF } from "jspdf";
import * as htmlToImage from 'html-to-image';
import { useNavigate, useParams } from 'react-router-dom';
import styleDetails from './Details.module.css';
import OwnerAndProviderData from '../../../components/taxDeclaration/ownerAndProviderData/OwnerAndProviderData';
import RealEstateData from '../../../components/taxDeclaration/realEstateData/RealEstateData';
import ParentRealEstateExploitation from '../../../components/taxDeclaration/realEstateExploitation/ParentRealEstateExploitation';
import logo from '../../../assets/img/pdf-logo.png';
import { get_tax_declaration_details } from '../../../adapters/apis/taxDeclaration/details';
import ParentAccessoriesAndFixedFittings from '../../../components/taxDeclaration/ParentAccessoriesAndFixedFittings/ParentAccessoriesAndFixedFittings';
import { FillOwnerAndProviderData } from './FillOwnerAndProviderData';
import { FillRealEstate } from './FillRealEstate';
import { FillResidential } from './FillResidentail';
import { FillAccessories } from './FillAccessories';
import ParentExploitedSpaceLand from '../../../components/taxDeclaration/parentExploitedSpaceLand/ParentExploitedSpaceLand';
import { FillExploitedSpaces } from './FillExploitedSpaces';
import ParentPetrolFacility from '../../../components/taxDeclaration/petrolFacility/ParentPetrolFacility';
import { FillPetrol } from './FillPetrol';
import ParentMinesQuarries from '../../../components/taxDeclaration/minesQuarries/ParentMinesQuarries';
import { FillMines } from './FillMines';
import ParentNonResidential from '../../../components/taxDeclaration/nonResidential/ParentNonResidential';
import { FillVillNonResidential } from './FillVillNonResidential';
import { FillGeneralNonResidentail } from './FillGeneralNonResidentail';
import ParentGeneralNonResidentail from '../../../components/taxDeclaration/parentGeneralNonResidentail/ParentGeneralNonResidentail';
import ParentHotelFacility from '../../../components/taxDeclaration/hotelFacility/ParentHotelFacility';
import { FillHotel } from './FillHotel';
import ParentCommercialRealEstate from '../../../components/taxDeclaration/commercialRealEstate/ParentCommercialRealEstate';
import { FillCommerical } from './FillCommerical';
import { FillIndependentService } from './FillIndependentService';
import ParentIndustrialFacility from '../../../components/taxDeclaration/industrialFacility/ParentIndustrialFacility';
import { FillIndustrial } from './FillIndustrial';
import { FillAirPort } from './FillAirPort';
import { FillPort } from './FillPort';
import ParentAirports from '../../../components/taxDeclaration/airports/ParentAirports';
import ParentPorts from '../../../components/taxDeclaration/ports/ParentPorts';
function Details() {
  const taxContext = useContext(TaxDeclartionContext);
  const { id } = useParams();
  const [component, setComponent] = useState();
  const use_navigate = useNavigate();
  const [declaration_num, setDeclarationNum] = useState(0);
  useEffect(() => {
    // call api to set tax declaration details and set default compoent depond on his choice
    get_tax_declaration_details(id).then(res => {
      FillOwnerAndProviderData(taxContext, res.data.data);
      FillRealEstate(taxContext, res.data.data);
      //fill resdientia data
      if (parseInt(res.data.data.declaration_real_estate.exploitation_type) === 1) {

        FillResidential(taxContext, res.data.data);
        setComponent(<ParentRealEstateExploitation preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 7 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 2) {
        FillAccessories(taxContext, res.data.data, 'parentAccessoriesAndFixedFittings');
        setComponent(<ParentAccessoriesAndFixedFittings preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 8 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 2) {
        FillExploitedSpaces(taxContext, res.data.data, 'parentExploitedSpaceLand');
        setComponent(<ParentExploitedSpaceLand preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 6 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 5) {
        FillPetrol(taxContext, res.data.data);
        setComponent(<ParentPetrolFacility preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 6 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 6) {
        FillMines(taxContext, res.data.data);
        setComponent(<ParentMinesQuarries preview={ true } />);
      } else if ((parseInt(res.data.data.declaration_real_estate.real_estate_type) === 1 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 2) ||
        (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 2 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 2) ||
        (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 3 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 2)) {
        FillVillNonResidential(taxContext, res.data.data);
        setComponent(<ParentNonResidential preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === -1 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 2) {
        FillGeneralNonResidentail(taxContext, res.data.data, 'parentGeneralNonResidentail');
        setComponent(<ParentGeneralNonResidentail preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 6 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 4) {
        FillHotel(taxContext, res.data.data);
        setComponent(<ParentHotelFacility preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 4) {
        FillCommerical(taxContext, res.data.data);
        setComponent(<ParentCommercialRealEstate preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 5) {
        FillIndependentService(taxContext, res.data.data);
        setComponent(<ParentCommercialRealEstate preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 6 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 3) {
        FillIndustrial(taxContext, res.data.data);
        setComponent(<ParentIndustrialFacility preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 6 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 7) {
        FillAirPort(taxContext, res.data.data);
        setComponent(<ParentAirports preview={ true } />);
      } else if (parseInt(res.data.data.declaration_real_estate.real_estate_type) === 6 && parseInt(res.data.data.declaration_real_estate.exploitation_type) === 8) {
        FillPort(taxContext, res.data.data);
        setComponent(<ParentPorts preview={ true } />);
      }

      setDeclarationNum(res.data.data.declaration_num);
    }).catch(err => {
      if (!err?.response) {
        console.log('No Server Response');
      } else if (err.response?.status === 500) {
        console.log('server error: ', err.response.data.message);
      } else if (err.response?.status === 404) {
        use_navigate('/not-found');
      }
    });

  }, [id, use_navigate]);

  const saveAsPDF = async () => {
    console.log("save p");

    // Get List of paged elements.
    let elems = document.querySelectorAll('.pdf-box');
    const pdf = new jsPDF();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let sumHeight = 15;
    for (let idx = 0; idx < elems.length; idx++) {

      htmlToImage.toPng(elems[idx], { quality: 0.95 })
        // eslint-disable-next-line no-loop-func
        .then(function (dataUrl) {
          var link = document.createElement('a');
          link.download = 'my-image-name.jpeg';
          const imgProps = pdf.getImageProperties(dataUrl);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          if (idx === 0) {
            pdf.addImage(logo, 'PNG', 145, 2, 60, 15);
            pdf.text(declaration_num, 5, 13, 0, 0);
          }
          if (pageHeight <= (sumHeight + pdfHeight)) {
            pdf.addPage();
            sumHeight = 15;
            pdf.addImage(logo, 'PNG', 145, 2, 60, 15);
            pdf.text(declaration_num, 5, 13, 0, 0);

          }
          if (idx < elems.length - 1) {
            pdf.addImage(dataUrl, 'PNG', 0, sumHeight, pdfWidth, pdfHeight);
            sumHeight += pdfHeight;
          } else {
            pdf.addImage(dataUrl, 'PNG', 0, sumHeight, pdfWidth, pdfHeight);
            pdf.save('TaxDeclartion.pdf');
          }

        });
      await delay(10);
    }

  };
  const delay = async (ms = 1000) =>
    new Promise(resolve => setTimeout(resolve, ms));
  return (
    <MainContent>
      <section className={ `${styleDetails["section-content"]} section-content` }>
        <div className={ `${styleDetails["header-all-btns"]} header-all-btns mb-5` }>
          <div className="container header-all-btns-flex">
            <div className={ `${styleDetails["btns-save"]} btns-save` }>
              <button className={ `${styleDetails["save-draft"]} save-draft` } onClick={ saveAsPDF }>تنزيل PDF</button>
            </div>
          </div>
        </div>
        <div className={ `${styleDetails.container} container pt-5` }>
          <div className={ `${styleDetails["card-box"]} card-box mt-5` }>


            <div className={ `${styleDetails["box-content"]} box-content box-details` }>
              <OwnerAndProviderData preview={ true } />
              <RealEstateData preview={ true } />
              { component }
            </div>
          </div>
        </div>
      </section>

    </MainContent>
  );
};

export default Details;